import React from 'react';
import { Loader } from 'hfs-common-ui';
import FormattedMessageWrapper from '~/components/views/FormattedMessageWrapper/FormattedMessageWrapper';

const YoutubePlaylistLoading: React.FC = () => {
  return (
    <div className="YoutubePlaylistLoading flex flex-col items-center">
      <Loader size="medium" variant="primary" center />
      <FormattedMessageWrapper langKey="web.youtube_playlist.loading_playlist" />
    </div>
  );
};

export default YoutubePlaylistLoading;
